<template>
    <table id="myTable" class="table order-list table-">
        <thead>
        <tr>
            <td class="">Item Name</td>
            <td class="">Unit Rate</td>
            <td class="">Quantity</td>
            <td class="">Delivery Date</td>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(row, index) in itemrows" :key="index" :class="{'bg-light' : !row.isNew}">
            <td class="">
                <select name="ItemId[]" v-model="row.ItemId" class="form-control" required>
                    <option v-for="(item, index) in newItems" :key="item.Id" :value="item.Id">{{ item.Name }}</option>
                </select>
            </td>
            <td class="">
                <input type="number" name="UnitRate[]" min="0" step=".01" v-model="row.UnitRate" class="form-control" required/>
            </td>
            <td class="">
                <input type="number" name="Quantity[]"  v-model="row.Quantity" class="form-control" required/>
            </td>
            <td class="">
                <input type="date" name="DeliveryDate[]"  v-model="row.DeliveryDate" class="form-control"/>
            </td>
            <td class="">
                <a class="btn btn-sm btn-danger text-white" @click="removeRow(index, row)">Delete</a>
            </td>
        </tr>
        </tbody>
        <tfoot>
        <tr>
            <td colspan="5">
                <div class="text-right">
                <button type="button" class="btn btn-lg btn-outline-info  w-25" v-on:click="addNewItemRow()" id="addrow">
                    Add row
                </button>
                </div>
            </td>
        </tr>
        </tfoot>
    </table>
</template>
<script>
    export default {
        name : 'purchase-order-item-list',
        props : ['newItems', 'PurchaseOrderId'],
        data(){
            return {
                itemrows: [
                    {
                        Id: null,
                        ItemId: null,
                        UnitRate: null,
                        Quantity: null,
                        DeliveryDate: null,
                        isNew: null,
                    }
                ],
                submitted:false,
                URLpurchaseOrderEditItemList: 'purchase-order/items/editlist',
                URLpurchaseOrderEditDeleteItem: 'purchase-order/items/deleteItem'
            }
        },
        methods:{
            addNewItemRow: function(){
                this.itemrows.push({
                    Id : null,
                    ItemId: null,
                    UnitRate: null,
                    Quantity: null,
                    DeliveryDate: null,
                    isNew: false,
                });

                this.itemrows = this.checkUniqueItems(this.itemrows, 'ItemId')
            },
            removeRow: function(index, row){
                if(!row.isNew){
                    return this.itemrows.splice(index, 1);
                }
                Swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!'
                }).then((result) => {
                    if (result.isConfirmed) {
                        // getting items of posted purchase order
                        axios.get(this.URLpurchaseOrderEditDeleteItem + '/' + row.Id)
                            .then(response => {
                                console.log(response.data)
                                Swal.fire(
                                    'Deleted!',
                                    'Your item has been deleted.',
                                    'success'
                                )
                                this.itemrows.splice(index, 1);
                            }).
                catch(error => {
                    this.errored = true
                })
                .finally(() => this.loading = false)


                    }
                })

            },
            checkUniqueItems: function(arr, key){
                var uniqueItems = [...new Map(arr.map(item => [item[key], item])).values()]
                return uniqueItems;
            },
            callItemsFromApi: function(purchaseOrderId){
                // getting items of posted purchase order
                axios.get(this.URLpurchaseOrderEditItemList + '/' + purchaseOrderId)
                    .then(response => {
                        this.itemrows = response.data.data
                    }).
                catch(error => {
                    this.errored = true
                })
                    .finally(() => this.loading = false)
            }
        },
        mounted() {
            this.callItemsFromApi(this.PurchaseOrderId)
        },
    }
</script>
